<template>
  <div>
    <template v-if="seekersStats === null">
      <div class="row">
        <div class="col-xs-12 text-center">
          loading data ...
          <div class="progress full m-t-xs" style="margin: 20px 0">
            <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="seekersStats.length === 0">
      <div class="row">
        <div class="col-xs-12 text-center">
          No Seeker registered
        </div>
      </div>
    </template>
    <template v-else v-for="(chunk, key) in statsChunks">
      <div class="row" :key="'chunk-' + key">
        <div class="col-xs-12 col-md-6 col-lg-4 col-xl-3" v-for="(stats, key2) in chunk" :key="key2">
          <div class="panel">
            <div class="panel-heading">
              {{stats.lastName}} {{stats.firstName}}
            </div>
            <div class="panel-body">
              <idx-radar v-if="stats.radar" :stats="stats.radar" :height="300"></idx-radar>
            </div>
            <div class="panel-footer text-center font-bold" v-if="stats.oi_score !== null">
              Oi Score: {{stats.oi_score }} %
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import IdxRadar from '../charts/IdxRadar'
import _ from 'lodash'

export default {
  components: {IdxRadar},
  props: [],
  name: 'SeekersStatsIo',
  data () {
    return {
      seekersStats: null
    }
  },
  computed: {
    statsChunks () {
      return _.chunk(Object.values(this.seekersStats), 12)
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/stats/seeker/ioStats').then((response) => {
        this.seekersStats = response.data

        this.seekersStats.sort((seeker1, seeker2) => {
          return seeker2.oi_score - seeker1.oi_score
        })
      }).catch((error) => {
      })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stats/seekersStatsIo.vue